<template>
  <div
    :id="`kdb_${secret}`"
    class="KdbArticle"
  >
    <VSkeletonLoader
      type="article"
      style="max-width: 500px; margin: 0 auto"
    />
  </div>
</template>

<script>
const hash = require('string-hash')

export default {
  props: {
    // e.g.: '66334_QIQfI8eDXkJaVjhxDhqXbgiqegzB7APJqU63hzyLBb'
    secret: { type: String, required: true },
  },
  mounted() {
    const { $store, secret } = this

    this.$kdbSources = [
      `//articles.it-solution.ru/api/v1/article.get.collection/${secret}/?js=true`,
      '//articles.it-solution.ru/api/v1/client.last/?link=articles/dist/commons.min.js',
      '//articles.it-solution.ru/api/v1/client.last/?link=articles/dist/pageArticleShare.min.js',
    ]
      .map(src => ({
        src,
        id: 'kdb-' + hash(src),
      }))
    this.$kdbSources
      .map(({ src, id }) => {
        const el = document.createElement('script')
        el.id = id
        el.src = src
        return el
      })
      .reduce( // synchronously append script elements
        (previousScriptLoaded, nextScript) =>
          previousScriptLoaded.then(() => { // after previous is loaded
            const nextLoaded = new Promise((resolve, reject) => { // listen load event
              const onLoad = () => {
                resolve()
                nextScript.removeEventListener('load', onLoad, false) // cleanup
              }
              const oneError = (e) => {
                reject(e)
                nextScript.removeEventListener('error', onLoad, false) // cleanup
              }
              nextScript.addEventListener('load', onLoad, false)
              nextScript.addEventListener('error', oneError, false)
            })
            document.body.appendChild(nextScript)
            return nextLoaded
          }),
        Promise.resolve(),
      )
      .catch((e) => {
        console.error(e)
        $store.dispatch('snackbar/showError', {
          message: `Невозможно отобразить статью, пожалуйста проверьте наличие
            интернет связи и перезагрузите страницу`,
          duration: null,
        })
      })
  },
  beforeDestroy() {
    const selector = this.$kdbSources.map(({ id }) => `#${id}`).join(',')
    Array.from(document.querySelectorAll(selector))
      .filter(el => el.parentNode)
      .forEach(el => el.parentNode.removeChild(el))
  },
}
</script>

<style lang="sass">
  .article-share-component img
    max-width: 100% !important
</style>
